// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"080908f2","821":"8a59c945"}[chunkId] + ".chunk.js";
};